/**
 * AIOD — refresh AJAX du cart drawer au lieu d'un rechargement de page
 * ---------------------------------------------------------------------------
 * L'app AIOD (échantillons automatiques) recharge toute la page après avoir
 * ajouté/retiré ses échantillons, car elle ne reconnaît pas le cart drawer de
 * ce thème (son re-render AJAX échoue et elle retombe sur un reload).
 *
 * AIOD expose un point d'extension : si `window.aiod_settings.cart_auto_reload_function`
 * est une chaîne JS non vide, AIOD l'exécute (via `Function("cartData", fn)`)
 * À LA PLACE du rechargement de page. Ce thème sait re-render le drawer en AJAX
 * via l'événement `cart:refresh` — c'est exactement ce que fait AIOD pour les
 * thèmes qu'elle connaît (ex. "reformation"). On fournit donc cette fonction
 * pour dispatcher `cart:refresh` et supprimer le reload.
 *
 * `cartData` est injecté par AIOD comme argument de la fonction (état du panier).
 */
(function () {
  'use strict';

  // Corps de la fonction qu'AIOD exécutera à la place du reload.
  var reloadFn =
    "document.documentElement.dispatchEvent(" +
    "new CustomEvent('cart:refresh', { bubbles: true }));";

  function applySetting() {
    window.aiod_settings = window.aiod_settings || {};
    if (window.aiod_settings.cart_auto_reload_function !== reloadFn) {
      window.aiod_settings.cart_auto_reload_function = reloadFn;
    }
  }

  // On l'applique tôt, et on le réaffirme un court instant au cas où AIOD
  // (re)définirait aiod_settings après le chargement de ce script.
  applySetting();
  var attempts = 0;
  var interval = setInterval(function () {
    applySetting();
    if (++attempts >= 20) clearInterval(interval); // ~10s puis on arrête
  }, 500);
})();

/**
 * Free-gift progress bar — auto-add / remove the configured gift variant
 * when the cart subtotal (excluding the gift itself) crosses the threshold.
 */
(function () {
  'use strict';

  var config = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.freeGift;
  if (!config || !config.enabled || !config.autoAdd || !config.variantId || !config.threshold) return;

  var GIFT_PROPERTY = '_free_gift';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var syncing = false;
  var cartJsonUrl = root + 'cart.js';
  var cartAddUrl = root + 'cart/add.js';
  var cartChangeUrl = root + 'cart/change.js';

  function isGiftItem(item) {
    if (!item) return false;
    var properties = item.properties || {};
    return properties[GIFT_PROPERTY] === 'true';
  }

  function qualifyingTotal(cart) {
    if (!cart || !cart.items) return 0;
    var sum = cart.items.reduce(function (total, item) {
      return isGiftItem(item) ? total : total + (item.final_line_price || 0);
    }, 0);
    var cartDiscount = 0;
    (cart.cart_level_discount_applications || []).forEach(function (application) {
      cartDiscount += application.total_allocated_amount || 0;
    });
    return Math.max(0, sum - cartDiscount);
  }

  function findGiftItem(cart) {
    if (!cart || !cart.items) return null;
    return cart.items.find(isGiftItem) || null;
  }

  function bundleSections() {
    var sections = new Set();
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sections }
      })
    );
    return Array.from(sections).join(',');
  }

  function dispatchCartChange(cart) {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'free-gift:sync',
          cart: cart
        }
      })
    );
  }

  function reloadIfCartPage() {
    if (window.themeVariables.settings.pageType === 'cart') {
      window.location.reload();
      return true;
    }
    return false;
  }

  async function addGift() {
    var sections = bundleSections();
    var response = await fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [
          {
            id: config.variantId,
            quantity: 1,
            properties: { _free_gift: 'true' }
          }
        ],
        sections: sections
      })
    });

    if (!response.ok) return false;

    if (reloadIfCartPage()) return true;

    var addJson = await response.json();
    var cart = await (await fetch(cartJsonUrl)).json();
    cart.sections = addJson.sections || {};
    dispatchCartChange(cart);
    return true;
  }

  async function changeGift(lineKey, quantity) {
    var sections = bundleSections();
    var response = await fetch(cartChangeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity,
        sections: sections
      })
    });

    if (!response.ok) return false;

    if (reloadIfCartPage()) return true;

    var cart = await response.json();
    dispatchCartChange(cart);
    return true;
  }

  async function syncGift(cart) {
    if (syncing || !cart) return;

    var gift = findGiftItem(cart);
    var reached = qualifyingTotal(cart) >= config.threshold;

    if (reached && !gift) {
      syncing = true;
      try {
        await addGift();
      } finally {
        syncing = false;
      }
    } else if (!reached && gift) {
      syncing = true;
      try {
        await changeGift(gift.key, 0);
      } finally {
        syncing = false;
      }
    } else if (reached && gift && gift.quantity > 1) {
      syncing = true;
      try {
        await changeGift(gift.key, 1);
      } finally {
        syncing = false;
      }
    }
  }

  document.addEventListener('cart:change', function (event) {
    if (event.detail && event.detail.baseEvent === 'free-gift:sync') return;
    syncGift(event.detail && event.detail.cart);
  });

  document.addEventListener('cart:refresh', function () {
    fetch(cartJsonUrl)
      .then(function (response) {
        return response.json();
      })
      .then(syncGift)
      .catch(function () {});
  });

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    fetch(cartJsonUrl)
      .then(function (response) {
        return response.json();
      })
      .then(syncGift)
      .catch(function () {});
  });

  fetch(cartJsonUrl)
    .then(function (response) {
      return response.json();
    })
    .then(syncGift)
    .catch(function () {});
})();

if (!window.customElements.get('free-gift-bar')) {
  window.customElements.define('free-gift-bar', class extends HTMLElement {});
}

/**
 * Klaviyo back-in-stock: Notify me opens a theme popup.
 * Tries to render the Klaviyo embed form; always offers a native email form
 * that submits via the Klaviyo Client BIS API.
 */
(function () {
  'use strict';

  var POPUP_ID = 'rx-klaviyo-bis-popup';
  var DEFAULT_FORM_ID = 'WpEKwU';
  var DEFAULT_COMPANY_ID = 'YkTeRw';
  var lastActivator = null;
  var embedTimer = null;
  var scriptPromise = null;

  function popupEl() {
    return document.getElementById(POPUP_ID);
  }

  function settings() {
    return (window.themeVariables && window.themeVariables.settings) || {};
  }

  function formId(popup) {
    return (
      (popup && popup.getAttribute('data-klaviyo-form-id')) ||
      settings().klaviyoBisFormId ||
      DEFAULT_FORM_ID
    ).trim();
  }

  function companyId(popup) {
    return (
      (popup && popup.getAttribute('data-klaviyo-company-id')) ||
      settings().klaviyoBisCompanyId ||
      DEFAULT_COMPANY_ID
    ).trim();
  }

  function ensureKlaviyoScript(id) {
    if (window.klaviyo && typeof window.klaviyo.push === 'function') {
      return Promise.resolve();
    }
    if (document.querySelector('script[src*="klaviyo.js"]')) {
      return Promise.resolve();
    }
    if (scriptPromise) return scriptPromise;

    scriptPromise = new Promise(function (resolve) {
      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' + encodeURIComponent(id);
      script.onload = resolve;
      script.onerror = resolve;
      document.head.appendChild(script);
      setTimeout(resolve, 4000);
    });

    return scriptPromise;
  }

  function embedIsPopulated(host) {
    if (!host) return false;
    if (host.classList.contains('klaviyo-form') && host.childElementCount > 0) return true;
    return Boolean(host.querySelector('form, iframe, input, button, [class*="klaviyo"]'));
  }

  function retryKlaviyoRender() {
    window.dispatchEvent(new Event('resize'));
    try {
      window.dispatchEvent(
        new CustomEvent('onsite-event-publish', {
          detail: {
            type: 'PAGE_CHANGE',
            previousPageUrl: window.location.href,
            currentPageUrl: window.location.origin + '/rx-klaviyo-bis/' + Date.now()
          }
        })
      );
    } catch (e) {}
  }

  function mountEmbed(popup) {
    var host = popup.querySelector('[data-klaviyo-bis-embed]');
    if (!host) return host;

    var id = formId(popup);
    var fresh = document.createElement('div');
    fresh.className = 'klaviyo-form-' + id;
    fresh.setAttribute('data-klaviyo-bis-embed', '');
    host.replaceWith(fresh);
    return fresh;
  }

  function showEmbed(popup, host) {
    if (!host || !embedIsPopulated(host)) return false;
    host.hidden = false;
    var nativeForm = popup.querySelector('[data-klaviyo-bis-native]');
    if (nativeForm) nativeForm.hidden = true;
    return true;
  }

  function setExpanded(expanded) {
    document.querySelectorAll('.rx-klaviyo-bis__button[aria-controls="' + POPUP_ID + '"]').forEach(function (button) {
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function setStatus(popup, message, isError) {
    var status = popup.querySelector('[data-klaviyo-bis-status]');
    if (!status) return;
    status.hidden = !message;
    status.textContent = message || '';
    status.classList.toggle('is-error', Boolean(isError));
  }

  function openPopup(button) {
    var popup = popupEl();
    if (!popup) return;

    lastActivator = button || null;
    popup.hidden = false;
    popup.classList.add('is-open');
    popup.removeAttribute('inert');
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('rx-klaviyo-bis-lock');
    setExpanded(true);
    setStatus(popup, '');

    popup.dataset.productId = button ? button.getAttribute('data-product-id') || '' : '';
    popup.dataset.variantId = button ? button.getAttribute('data-variant-id') || '' : '';

    var nativeForm = popup.querySelector('[data-klaviyo-bis-native]');
    if (nativeForm) {
      nativeForm.hidden = false;
      nativeForm.reset();
    }

    var embedHost = mountEmbed(popup);
    if (embedHost) embedHost.hidden = false;

    var emailInput = popup.querySelector('#rx-klaviyo-bis-email');
    if (emailInput) emailInput.focus();

    ensureKlaviyoScript(companyId(popup)).then(function () {
      retryKlaviyoRender();
      if (embedTimer) clearInterval(embedTimer);
      var attempts = 0;
      embedTimer = setInterval(function () {
        attempts += 1;
        if (showEmbed(popup, popup.querySelector('[data-klaviyo-bis-embed]')) || attempts >= 12) {
          clearInterval(embedTimer);
          embedTimer = null;
        } else {
          retryKlaviyoRender();
        }
      }, 400);
    });
  }

  function closePopup() {
    var popup = popupEl();
    if (!popup || !popup.classList.contains('is-open')) return;

    if (embedTimer) {
      clearInterval(embedTimer);
      embedTimer = null;
    }

    popup.classList.remove('is-open');
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('rx-klaviyo-bis-lock');
    setExpanded(false);

    if (lastActivator && typeof lastActivator.focus === 'function') {
      lastActivator.focus();
    }
    lastActivator = null;
  }

  async function submitNative(event) {
    event.preventDefault();
    var popup = popupEl();
    if (!popup) return;

    var form = event.target;
    var emailInput = form.querySelector('input[type="email"]');
    var email = emailInput ? emailInput.value.trim() : '';
    var submitButton = form.querySelector('button[type="submit"]');
    var variantId = popup.dataset.variantId;

    if (!email || (emailInput && !emailInput.checkValidity())) {
      if (emailInput) emailInput.reportValidity();
      return;
    }

    if (submitButton) submitButton.disabled = true;
    setStatus(popup, '');

    var ok = false;
    try {
      var response = await fetch(
        'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(companyId(popup)),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2025-04-15'
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email: email }
                  }
                }
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: '$shopify:::$default:::' + variantId
                  }
                }
              }
            }
          })
        }
      );
      ok = response.ok || response.status === 202;
    } catch (e) {
      ok = false;
    }

    if (!ok) {
      try {
        window.klaviyo = window.klaviyo || [];
        window.klaviyo.push(['identify', { email: email }]);
        window.klaviyo.push([
          'track',
          'Requested Back in Stock',
          { ProductID: popup.dataset.productId, VariantId: variantId }
        ]);
        ok = true;
      } catch (e) {}
    }

    if (submitButton) submitButton.disabled = false;

    if (ok) {
      setStatus(popup, popup.getAttribute('data-success-message') || '');
      form.hidden = true;
    } else {
      setStatus(popup, popup.getAttribute('data-error-message') || '', true);
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('.rx-klaviyo-bis__button');
      if (button) {
        event.preventDefault();
        event.stopPropagation();
        openPopup(button);
        return;
      }

      if (event.target.closest('[data-klaviyo-bis-close]') || event.target.closest('[data-klaviyo-bis-overlay]')) {
        event.preventDefault();
        closePopup();
      }
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closePopup();
  });

  document.addEventListener(
    'submit',
    function (event) {
      if (event.target.matches('[data-klaviyo-bis-native]')) {
        submitNative(event);
        return;
      }
      if (event.target.matches('form[action*="/cart/add"]') && event.target.querySelector('.rx-klaviyo-bis__button')) {
        event.preventDefault();
      }
    },
    true
  );
})();

class RxCollapsibleText extends HTMLElement {
  connectedCallback() {
    this.contentEl = this.querySelector('.rx-collapsible-text__content');
    this.toggleEl = this.querySelector('.rx-collapsible-text__toggle');

    if (!this.contentEl || !this.toggleEl) return;

    this.maxHeight = parseInt(this.getAttribute('max-height'), 10) || 300;
    this.toggleEl.addEventListener('click', this.onToggleClick.bind(this));

    requestAnimationFrame(() => this.measure());
  }

  measure() {
    const isOverflowing = this.contentEl.scrollHeight > this.maxHeight;

    this.classList.toggle('rx-collapsible-text--collapsible', isOverflowing);

    if (isOverflowing) {
      this.contentEl.style.maxHeight = `${this.maxHeight}px`;
    } else {
      this.toggleEl.hidden = true;
    }
  }

  onToggleClick() {
    const isExpanded = this.classList.toggle('rx-collapsible-text--expanded');

    this.contentEl.style.maxHeight = isExpanded ? `${this.contentEl.scrollHeight}px` : `${this.maxHeight}px`;
    this.toggleEl.setAttribute('aria-expanded', isExpanded);
    this.toggleEl.querySelector('.rx-collapsible-text__toggle-label').textContent = isExpanded
      ? this.toggleEl.dataset.labelLess
      : this.toggleEl.dataset.labelMore;
  }
}

if (!window.customElements.get('rx-collapsible-text')) {
  window.customElements.define('rx-collapsible-text', RxCollapsibleText);
}
